import { ComunicacionService } from './../../services/comunicacionService/comunicacion.service';
import { RouteInfo } from './sidebar.metadata';
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { LoginService } from "../../services/login/login.service";
import { SecurityService } from '../../services/security/security.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MessagesTitles,MessagesStatus } from '../../models/messages';
import Swal from "sweetalert2";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.css"],
  providers:[MessagesTitles,MessagesStatus]
})
export class SidebarComponent implements OnInit {
  public sidebarItems: any[];
  bgImageUrl:string = "";
  Codigo : any = "LOGO_EMPRESA";
  color = sessionStorage.getItem("color"); 
  ParametrosList : any;
  dataPermiso:any = [] ;
  user:any;
  minimo: boolean = false;  
  reloadPermiso:boolean = false;
  public menuItems: any[];
  ROUTES: RouteInfo[] = [];
  data404:any;

  constructor(private securityService:SecurityService,private router: Router, private loginService: LoginService,private msgTitulos : MessagesTitles,private msgStatus:MessagesStatus,private comunicacionService:ComunicacionService) {
    this.user = JSON.parse(sessionStorage.getItem("UserActive"));
    this.reloadPermiso = this.loginService.reloadPermiso; 
    this.data404 =this.comunicacionService.data
    if(this.loginService.dataPermiso){
      this.dataPermiso = this.loginService.dataPermiso
      var hash = {};
      this.dataPermiso = this.dataPermiso.filter(function(current) {
        var exists = !hash[current.id_componente];
        hash[current.id_componente] = true;
        return exists;
      });
      this.GetArrayComponentes();
    } 
  }
  isNotMobileMenu(){
    if($(window).width() > 991){
        return false;
    }
    return true;
  }

  ngOnInit(){
    if (this.reloadPermiso) {
      this.loginService.reloadPermiso = false;
      this.ObtenerPermisosPorRol(this.user.id_roles)
    }else{
      this.sidebarItems = this.ROUTES.filter(menuItem => menuItem);
    }
    this.obtenerParametros()
  }

  GetArrayComponentes(){
     
    this.dataPermiso.forEach((item,index) => {
      if  (item.id_componente_padre == 0){
        this.ROUTES.push(item);
      }

      let idUlti = 300
      if (!this.data404){
        for(let i=1;i<idUlti+1 ;i++){
          if (item.id_componente_padre ==i){
            let indexx = this.ROUTES.findIndex( ruta => ruta.id_componente ==i );
            if(indexx >= 0)this.ROUTES[indexx].submenu.push(item);
          }
        }
      }
    });
  }

  isMobileMenu() {
    if ($(window).width() > 991) {
      return false;
    } else {
      localStorage.setItem("minimo", "false");
      return true;
    }
  }

  ObtenerPermisosPorRol(id_roles : number){
    this.securityService.ObtenerPermisosPorRol(id_roles).subscribe(
      resp => {
        this.dataPermiso = resp
        for (const iterator of this.dataPermiso) {
          iterator.submenu = [];
        }

        var hash = {};
        this.dataPermiso = this.dataPermiso.filter(function(current1) {
          var exists = !hash[current1.id_componente];
          hash[current1.id_componente] = true;
          return exists;
        });
        
        this.GetArrayComponentes();
        this.sidebarItems = this.ROUTES.filter(menuItem => menuItem);
        this.loginService.dataPermiso = this. dataPermiso;
      }, (err: HttpErrorResponse)=> {
        this.msgStatus.getMessage(err.status);
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "Listado de permisos no obtenida. "+this.msgStatus.message,
          type: "error",
          allowOutsideClick: false
        });
      }
    )
  }

  CerrarSession() {
    sessionStorage.clear();
     this.loginService.TOKEN = "";
    this.router.navigate(['/login']);
  }
  clickGuard(){
    this.loginService.clickGuard = true;
  }

  obtenerParametros(){
    this.securityService.ObtenerParametros(this.user.id_empresa)
    .subscribe(res => {
      this.ParametrosList = res;
      this.ParametrosList =  this.ParametrosList.filter(cta => cta.Codigo == this.Codigo);
      if(this.ParametrosList[0].Valor.lenght != 0){
        this.bgImageUrl = this.ParametrosList[0].Valor
      }
    }
      )
    }
}